import { useTimeAgo } from '@vueuse/core';
import { computed } from 'vue';
import i18n from '../locales/i18n';

const { t } = i18n.global;
export const timeFormat = (milliseconds) => {
    const timeAgo = useTimeAgo(milliseconds);

    return timeAgo.value;
};
export const useDay = (dayNumber) => {
    const daysOfWeek = computed(() => [t('week.sunday'), t('week.monday'), t('week.tuesday'), t('week.wednesday'), t('week.thursday'), t('week.friday'), t('week.saturday')]);

    return daysOfWeek.value[dayNumber];
};

export const useMonth = (monthNumber) => {
    const months = [t('month.january'), t('month.february'), t('month.march'), t('month.april'), t('month.may'), t('month.june'), t('month.july'), t('month.august'), t('month.september'), t('month.october'), t('month.november'), t('month.december')];

    return months[monthNumber - 1];
};

export const useDate = (date) => {
    const localDate = new Date(date);

    const day = localDate.getDate();
    const month = localDate.getMonth() + 1; // добавляем 1, так как месяцы начинаются с 0
    const year = localDate.getFullYear();

    // Формируем строку с нужным форматом ДД.ММ.ГГ
    const formattedDate = `${day < 10 ? '0' + day : day}.${month < 10 ? '0' + month : month}.${year}`;

    return formattedDate;
};

export const useDurationFormatInput = (date) => {
    const digits = date.replace(/\D/g, '').slice(0, 6);
    let hours = '';
    let minutes = '';
    let seconds = '';

    if (digits.length >= 1) {
        hours = digits.slice(0, 2);
    }
    if (digits.length >= 3) {
        minutes = digits.slice(2, 4);
        if (parseInt(minutes) > 59) minutes = '59';
    }
    if (digits.length >= 5) {
        seconds = digits.slice(4, 6);
        if (parseInt(seconds) > 59) seconds = '59';
    }

    if (digits.length >= 5) {
        return `${hours}:${minutes}:${seconds}`;
    } else if (digits.length >= 3) {
        return `${hours}:${minutes}`;
    } else {
        return hours;
    }
};
